import React, { useState, useEffect } from "react";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminCustomArea from "../../../../components/CommonComponents/AdminCustomArea";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";

const PushNotification = () => {
    const { fetchRequest } = useMyContext();
    const baseURL = process.env.REACT_APP_Baseurl;
    const apiIndex = `${baseURL}/admin/push-notification/index`;
    const apiStore = `${baseURL}/admin/push-notification/store`;

    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);

    const [formData, setFormData] = useState({
        vapid_public_key: "",
        vapid_private_key: "",
        firebase_config: "",
        service_account_json: "",
        status: 1
    });

    useEffect(() => {
        const loadSettings = async () => {
            setLoading(true);
            try {
                const response = await fetchRequest({
                    method: 'GET',
                    url: apiIndex,
                });
                if (response?.status && response?.pushNotification) {
                    const data = response.pushNotification;
                    setFormData({
                        vapid_public_key: data.vapid_public_key || "",
                        vapid_private_key: data.vapid_private_key || "",
                        firebase_config: data.firebase_config || "",
                        service_account_json: data.service_account_json || "",
                        status: data.status ?? 1
                    });
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || "Failed to load settings");
            } finally {
                setLoading(false);
            }
        };
        loadSettings();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        setShowOverlay(true);
        try {
            const response = await fetchRequest({
                method: 'POST',
                url: apiStore,
                data: formData,
            });
            if (response?.status) {
                toast.success(response.message || "Settings saved successfully");
            } else {
                toast.error(response?.message || "Failed to save settings");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setShowOverlay(false);
        }
    };

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />;
    }

    return (
        <>
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation text="Back" path="/settings" />
            <AdminSaveHeader heading={"Push Notification Settings"} saveText={"Save Settings"} saveMethod={handleSave} loading={showOverlay} />

            <FormContainer>
                <Wrapper className="w-100">
                    <MessageHeading text="VAPID Keys" />
                    <div className="row mb-3">
                        <div className="col-md-12">
                            <MessageLabel text="VAPID Public Key" />
                            <AdminCustomInput
                                type="text"
                                name="vapid_public_key"
                                value={formData.vapid_public_key}
                                onChange={handleChange}
                                placeHolder="Enter VAPID Public Key"
                            />
                        </div>
                        <div className="col-md-12">
                            <MessageLabel text="VAPID Private Key" />
                            <AdminCustomInput
                                type="password"
                                name="vapid_private_key"
                                value={formData.vapid_private_key}
                                onChange={handleChange}
                                placeHolder="Enter VAPID Private Key"
                            />
                        </div>
                    </div>

                    <MessageHeading text="Firebase Configuration" />
                    <div className="row mb-3">
                        <div className="col-md-12 mb-3">
                            <MessageLabel text="Firebase Web Config (JSON)" />
                            <AdminCustomArea
                                name="firebase_config"
                                rows="6"
                                value={formData.firebase_config}
                                onChange={handleChange}
                                placeHolder='{"apiKey": "...", "authDomain": "...", ...}'
                            />
                            <small className="text-muted">Enter the JSON configuration from Firebase Console (Web App settings).</small>
                        </div>
                        <div className="col-md-12">
                            <MessageLabel text="Service Account Key (JSON)" />
                            <AdminCustomArea
                                name="service_account_json"
                                rows="8"
                                value={formData.service_account_json}
                                onChange={handleChange}
                                placeHolder='{"type": "service_account", "project_id": "...", ...}'
                            />
                            <small className="text-muted">Enter the content of your Firebase Service Account JSON file.</small>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <MessageLabel text="Status" />
                            <select
                                className="form-select theme-bg-color text-color"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={1}>Enabled</option>
                                <option value={0}>Disabled</option>
                            </select>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <AdminCustomButton id="push-notification-save" className="px-3 py-1 m-0" saveMethod={handleSave} saveText="Save Settings" />
                    </div>
                </Wrapper>
            </FormContainer>
        </>
    );
};

export default PushNotification;